export const commonActionTypes = {
  SET_MESSAGE: "SET_MESSAGE",
  CLEAR_MESSAGE: "CLEAR_MESSAGE",
  SET_BREAD_CRUMB: "SET_BREAD_CRUMB",
  SHOW_LOADING_PAGE: "SHOW_LOADING_PAGE",
  SET_STATUS_FORM_VIEW: "SET_STATUS_FORM_VIEW",
  SET_REFERRAL_CODE: "SET_REFERRAL_CODE",
  SET_STATUS_SEARCH_POPOVER: "SET_STATUS_SEARCH_POPOVER",
};

export default {
  setMessage: (message) => ({
    type: commonActionTypes.SET_MESSAGE,
    message,
  }),
  showLoadingPage: (showLoadingPageIcon) => ({
    type: commonActionTypes.SHOW_LOADING_PAGE,
    showLoadingPageIcon,
  }),
  clearMessage: () => ({
    type: commonActionTypes.CLEAR_MESSAGE,
  }),
  updateNode: (breadCrumbs) => ({
    type: commonActionTypes.SET_BREAD_CRUMB,
    breadCrumbs,
  }),
  setStatusOfFormView: (params) => ({
    type: commonActionTypes.SET_STATUS_FORM_VIEW,
    params,
  }),
  setStatusOfSearchPopover: (status) => ({
    type: commonActionTypes.SET_STATUS_SEARCH_POPOVER,
    status,
  }),
  setReferralCode: (referralCode) => ({
    type: commonActionTypes.SET_REFERRAL_CODE,
    referralCode,
  }),
};
